import {
  NR01CreateStockGruppeRequest,
  NR01CreateStockGruppeResponse,
  NR01DeleteStockGruppeResponse,
  NR01StockGruppeResponse,
  NR01UpdateStockGruppeRequest,
  NR01UpdateStockGruppeResponse,
} from '../../models/NR01StockGruppeOverview';
import * as actionTypesNR01 from './actionTypesNR01';

export const fetchNR01StockGruppeRequest = (
  companyId: number,
  page: number,
  pageSize: number,
  search?: string,
  sortBy?: string,
  sortDirection?: string,
) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_GET,
  payload: { companyId, page, pageSize, search, sortBy, sortDirection },
});

export const fetchNR01StockGruppeSuccess = (data: NR01StockGruppeResponse) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_SUCCESS,
  payload: data,
});

export const fetchNR01StockGruppeFailure = (error: string) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_FAILURE,
  payload: error,
});

// The next page when the user scrolls to the bottom of the table: appended to the rows already shown.
export const loadMoreNR01StockGruppeRequest = (
  companyId: number,
  page: number,
  pageSize: number,
  search?: string,
  sortBy?: string,
  sortDirection?: string,
) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_LOAD_MORE,
  payload: { companyId, page, pageSize, search, sortBy, sortDirection },
});

export const loadMoreNR01StockGruppeSuccess = (data: NR01StockGruppeResponse) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_LOAD_MORE_SUCCESS,
  payload: data,
});

export const loadMoreNR01StockGruppeFailure = (error: string) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_LOAD_MORE_FAILURE,
  payload: error,
});

export const deleteNR01StockGruppeRequest =(companyId: number, groupNumber: string) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_DELETE,
  payload: { companyId, groupNumber },
});

export const deleteNR01StockGruppeSuccess = (data: NR01DeleteStockGruppeResponse) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_DELETE_SUCCESS,
  payload: data,
});

export const deleteNR01StockGruppeFailure = (error: string) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_DELETE_FAILURE,
  payload: error,
});

export const createNR01StockGruppeRequest = (
  companyId: number,
  payload: NR01CreateStockGruppeRequest,
) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_CREATE,
  payload: { companyId, payload },
});

export const createNR01StockGruppeSuccess = (data: NR01CreateStockGruppeResponse) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_CREATE_SUCCESS,
  payload: data,
});

export const createNR01StockGruppeFailure = (error: string) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_CREATE_FAILURE,
  payload: error,
});

export const updateNR01StockGruppeRequest = (
  companyId: number,
  groupNumber: string,
  payload: NR01UpdateStockGruppeRequest,
) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_UPDATE,
  payload: { companyId, groupNumber, payload },
});

export const updateNR01StockGruppeSuccess = (data: NR01UpdateStockGruppeResponse) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_UPDATE_SUCCESS,
  payload: data,
});

export const updateNR01StockGruppeFailure = (error: string) => ({
  type: actionTypesNR01.NR01_STOCKGRUPPE_UPDATE_FAILURE,
  payload: error,
});

export const resetNR01 = () => ({
  type: actionTypesNR01.NR01_RESET,
});
